export class EVENTS {
  public static LOCK = 'lock';
  public static UNLOCK = 'unlock';
  public static LOCK_FORWARD = 'lockForward';
  public static COMPLETED = 'completed';
  public static REFRESHED = 'refreshed';
}

export class KNOWLEDGE_CHECK_EVENTS {
  public static OPTION_MOUNTED = 'kc-option-mounted';
  public static AFTER_OPTION_COMPLETED_MOUNTED = 'kc-option-completed-mounted';

  public static AFTER_OPTION_MOUNTED = 'kc-after-mounted';
  public static CLEAR_OPTIONS = 'kc-clear-options';
  public static CONTEXT_OPTION_SELECTED = 'kc-context-option-selected';
  public static OPTION_SELECTED = 'kc-option-selected';
  public static MOUNTED = 'kc-mounted';
  public static SHOWING_FEEDBACK = 'kc-showing-feedback';
  public static TURN_INTO_FOLDER_POOL = 'kc-turn-it-into-folder-pool';
  public static NEXT = 'kc-next';
  public static SHOW_FINAL_FEEDBACK = 'kc-show-final-feedback';
  public static IS_LAST_QUESTION = 'kc-is-last-question';
  public static HAS_LEARN_MORE_CONTENT = 'has-learn-more-content';
  public static HAS_EVALUATED_ANSWER = 'has-evaluated-answer';
}

export class QUIZ_FOLDER_PATH {
  public static ROOT = 'root';
}
export class INTERACTIONS {
  public static URN_PREFIX = 'urn:kb4:btb';
  public static URN_QUIZ = `${INTERACTIONS.URN_PREFIX}-interaction-quiz`;
} 